import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-gold text-navy hover:bg-gold-dark font-bold shadow-md hover:shadow-lg',
    secondary: 'bg-navy text-white hover:bg-navy-light font-semibold shadow-md hover:shadow-lg',
    outline: 'border-2 border-navy text-navy hover:bg-navy/5 font-semibold',
    ghost: 'text-navy hover:bg-navy/5 font-medium'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={cn('inline-flex items-center justify-center rounded-lg transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none', variants[variant], sizes[size], className)} {...props} data-id="element-451" />;
}